<div class="wrap">
  <app-header></app-header>
  <div class="main-holder">
    <app-nav></app-nav>
    <div class="main">
      <div class="main-content">
        <div class="bread">
          <ol>
            <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg" alt="Home"></a></li>
            <img src="../../../../assets/okito/images/icons/chevron-right.svg" alt="">
            <li><a [routerLink]="['/admin/taxi-fleet']">Taxi Fleet Management</a></li>
            <img src="../../../../assets/okito/images/icons/chevron-right.svg" alt="">
            <li><span>Fleet Operator Details</span></li>
          </ol>
        </div>

        <div class="empty-state" *ngIf="isLoading">
          <h4>Loading Taxi Fleet details...</h4>
        </div>

        <div class="empty-state" *ngIf="!isLoading && detailError">
          <img src="../../../../assets/okito/images/empty.svg" alt="">
          <h4>Unable to load details.</h4>
          <small>{{ detailError }}</small>
        </div>

        <ng-container *ngIf="!isLoading && !detailError && fleet">
          <div class="profile-holder">
            <div class="profile">
              <div class="profile-info">
                <h4>{{ fleet.operatorName }}</h4>
                <div class="tags">
                  <span class="stat" [ngClass]="getStatusClass(fleet.status)">{{ getStatusLabel(fleet.status) }}</span>
                </div>
              </div>
            </div>
            <div class="profile-actions" *ngIf="activeTab === 'details'">
              <ng-container *ngIf="fleet.status === 'FOR_APPROVAL'">
                <button type="button" class="btn btn-sm btn-outline" [disabled]="isUpdatingStatus || stagedAmendments.length > 0 || hasDocumentsForAmendment" (click)="openDeclineEnrollmentModal(declineEnrollmentModal)">
                  Decline
                </button>
                <button type="button" class="btn btn-sm btn-outline" [disabled]="isUpdatingStatus || isReviewingDocument || stagedAmendments.length === 0" (click)="openAmendmentSummaryModal(amendmentSummaryModal)">
                  For Amendment
                </button>
                <button type="button" class="btn btn-sm btn-default" [disabled]="isUpdatingStatus || isReviewingDocument || !canApproveEnrollment" (click)="openApproveModal(approveModal)">
                  Approve
                </button>
              </ng-container>
              <button
                *ngIf="fleet.status === 'FOR_AMENDMENT'"
                type="button"
                class="btn btn-sm btn-outline"
                [disabled]="isUpdatingStatus"
                (click)="onResendAmendmentEmail()">
                Resend For Amendment Email
              </button>
              <button
                *ngIf="fleet.status === 'FOR_AMENDMENT'"
                type="button"
                class="btn btn-sm btn-outline"
                [disabled]="isUpdatingStatus || stagedAmendments.length === 0"
                (click)="openAmendmentSummaryModal(amendmentSummaryModal)">
                Send Additional Amendments
              </button>
              <button
                *ngIf="canDeactivateOperator(fleet.status)"
                type="button"
                class="btn btn-sm btn-outline"
                [disabled]="isUpdatingStatus"
                (click)="openDeactivateModal(deactivateModal)">
                Deactivate
              </button>
              <button
                *ngIf="canActivateOperator(fleet.status)"
                type="button"
                class="btn btn-sm btn-default"
                [disabled]="isUpdatingStatus"
                (click)="openActivateModal(activateModal)">
                Activate
              </button>
              <button *ngIf="fleet.status !== 'FOR_AMENDMENT'" type="button" class="btn btn-sm btn-outline" [disabled]="isUpdatingStatus" (click)="onResendCredentials(resendCredentialsModal)">
                Resend Log-in Credentials
              </button>
              <button *ngIf="fleet.status !== 'FOR_AMENDMENT'" type="button" class="btn btn-sm btn-default" [disabled]="isUpdatingStatus" (click)="onEdit(editFleetModal)">
                Edit
              </button>
            </div>
          </div>

          <div class="list-tabs details-tabs">
            <ul>
              <li [class.active]="activeTab === 'details'">
                <a href="#" (click)="$event.preventDefault(); setActiveTab('details')">Fleet Details</a>
              </li>
              <li [class.active]="activeTab === 'registry'">
                <a href="#" (click)="$event.preventDefault(); setActiveTab('registry')">Fleet Registry</a>
              </li>
            </ul>
          </div>

          <div class="form-level-error" *ngIf="statusUpdateError" style="margin-top: 16px;">
            <i class="fa fa-exclamation-circle"></i> {{ statusUpdateError }}
          </div>

          <ng-container *ngIf="activeTab === 'details'">
            <!-- Operator Details -->
            <div class="panel">
              <h3>Operator Details</h3>
              <div class="panel-info">
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Taxi Fleet Operator Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.operatorName || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Registered Business Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.registeredBusinessName || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Fleet ID</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.fleetCode || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Fleet Type</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="(fleet.fleetType | titlecase) || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Number of Allowed Active Vehicles</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.allowedActiveVehicles != null ? fleet.allowedActiveVehicles : '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Created At</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.dateCreated ? (fleet.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A') : '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Updated At</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.dateUpdated ? (fleet.dateUpdated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A') : '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Taxi Fleet Enrollment Status</label>
                    <div class="col-sm-9">
                      <div class="detail-inline">
                        <span class="stat" [ngClass]="getStatusClass(fleet.status)">{{ getStatusLabel(fleet.status) }}</span>
                      </div>
                      <div
                        class="form-level-error"
                        *ngIf="(fleet.status === 'FOR_APPROVAL' || fleet.status === 'INACTIVE') && hasMissingRequirements"
                        style="margin-top: 12px;">
                        <i class="fa fa-exclamation-circle"></i> Please complete the required fields.
                        <ul style="margin: 8px 0 0 18px;">
                          <li *ngFor="let req of fleet.missingRequirements">Enter {{ requirementLabel(req) }}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="panel-grp" *ngIf="fleet.declineRemarks">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Decline Reason</label>
                    <div class="col-sm-9">
                      <div class="detail-field"><span class="detail-value">{{ fleet.declineRemarks }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Operator's Representative -->
            <div class="panel">
              <h3>Operator's Representative</h3>
              <div class="panel-info">
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">First Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.representativeFirstName || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Last Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.representativeLastName || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Mobile Number</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.representativeMobile || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Representative Email</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="fleet.representativeEmail || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Valid ID Doc</label>
                    <div class="col-sm-9">
                      <div class="detail-field" *ngIf="validIdDocument as doc; else noValidId">
                        <div class="detail-doc">
                          <div class="docs-holder">
                            <img [src]="doc.documentUrl" alt="Valid ID" (error)="onDocumentImageError(doc)">
                          </div>
                          <a [href]="doc.documentUrl" target="_blank" rel="noopener">View Document</a>
                        </div>
                        <p class="amend-note" *ngIf="isDocumentLoadFailed(doc)"><i class="fa fa-exclamation-circle"></i> {{ documentLoadErrorMessage() }}</p>
                        <button type="button" class="detail-amend" *ngIf="canTagDocumentForAmendment(doc)" (click)="openReviewDocumentModal(reviewDocumentModal, doc, 'FOR_AMENDMENT')">Tag for Amendment</button>
                        <button type="button" class="detail-approve" *ngIf="canApproveDocument(doc)" (click)="openReviewDocumentModal(reviewDocumentModal, doc, 'APPROVED')">Approve</button>
                        <span class="stat" [ngClass]="getDocumentStatusClass(doc)">{{ getDocumentStatusLabel(doc) }}</span>
                      </div>
                      <p class="amend-note" *ngIf="validIdDocument?.remarks as note"><i class="fa fa-exclamation-circle"></i> {{ note }}</p>
                      <ul class="doc-history" *ngIf="validIdDocument && documentHistory(validIdDocument).length">
                        <li *ngFor="let entry of documentHistory(validIdDocument)">
                          <strong>{{ historyActionLabel(entry.action) }}</strong>
                          <span *ngIf="entry.adminName"> · {{ entry.adminName }}</span>
                          <span *ngIf="entry.remarks"> — {{ entry.remarks }}</span>
                          <small>{{ entry.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A' }}</small>
                        </li>
                      </ul>
                      <ng-template #noValidId>
                        <div class="detail-field"><span class="detail-value">No document attached.</span></div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel" *ngIf="otherDocuments.length > 0">
              <h3>Uploaded Documents</h3>
              <div class="panel-info">
                <div class="panel-grp" *ngFor="let doc of otherDocuments; let i = index">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">{{ getDocumentLabel(doc, i) }}</label>
                    <div class="col-sm-9">
                      <div class="detail-doc">
                        <div class="docs-holder">
                          <img [src]="doc.documentUrl" alt="Uploaded document" (error)="onDocumentImageError(doc)">
                        </div>
                        <a [href]="doc.documentUrl" target="_blank" rel="noopener"><i class="fa fa-download"></i> Download Document</a>
                      </div>
                      <p class="amend-note" *ngIf="isDocumentLoadFailed(doc)"><i class="fa fa-exclamation-circle"></i> {{ documentLoadErrorMessage() }}</p>
                      <div class="detail-field doc-actions">
                        <button type="button" class="detail-amend" *ngIf="canTagDocumentForAmendment(doc)" (click)="openReviewDocumentModal(reviewDocumentModal, doc, 'FOR_AMENDMENT')">Tag for Amendment</button>
                        <button type="button" class="detail-approve" *ngIf="canApproveDocument(doc)" (click)="openReviewDocumentModal(reviewDocumentModal, doc, 'APPROVED')">Approve</button>
                        <span class="stat" [ngClass]="getDocumentStatusClass(doc)">{{ getDocumentStatusLabel(doc) }}</span>
                      </div>
                      <p class="amend-note" *ngIf="doc.remarks as note"><i class="fa fa-exclamation-circle"></i> {{ note }}</p>
                      <ul class="doc-history" *ngIf="documentHistory(doc).length">
                        <li *ngFor="let entry of documentHistory(doc)">
                          <strong>{{ historyActionLabel(entry.action) }}</strong>
                          <span *ngIf="entry.adminName"> · {{ entry.adminName }}</span>
                          <span *ngIf="entry.remarks"> — {{ entry.remarks }}</span>
                          <small>{{ entry.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A' }}</small>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Accreditation Details -->
            <div class="panel">
              <h3>Accreditation Details</h3>
              <div class="panel-info">
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Valid LTFRB CPC Number</label>
                    <div class="col-sm-9">
                      <div class="detail-field">
                        <span class="detail-value">{{ fleet.ltfrbCpcNumber || '-' }}</span>
                        <button type="button" class="detail-amend" *ngIf="fleet.status === 'FOR_APPROVAL' || fleet.status === 'FOR_AMENDMENT'" (click)="openTagForAmendmentModal(tagForAmendmentModal, 'Valid LTFRB CPC Number')">{{ getStagedAmendment('Valid LTFRB CPC Number') ? 'Edit Message' : 'Tag for Amendment' }}</button>
                        <span class="stat" [ngClass]="getStagedAmendment('Valid LTFRB CPC Number') ? 'stat-amend' : 'stat-review'" *ngIf="fleet.status === 'FOR_APPROVAL' || fleet.status === 'FOR_AMENDMENT'">{{ getStagedAmendment('Valid LTFRB CPC Number') ? 'For Amendment' : 'For Review' }}</span>
                      </div>
                      <p class="amend-note" *ngIf="getStagedAmendment('Valid LTFRB CPC Number') as note"><i class="fa fa-exclamation-circle"></i> {{ note.message }}</p>
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">CPC Expiration Date</label>
                    <div class="col-sm-9">
                      <div class="detail-field">
                        <span class="detail-value">{{ fleet.cpcExpirationDate || '-' }}</span>
                        <button type="button" class="detail-amend" *ngIf="fleet.status === 'FOR_APPROVAL' || fleet.status === 'FOR_AMENDMENT'" (click)="openTagForAmendmentModal(tagForAmendmentModal, 'CPC Expiration Date')">{{ getStagedAmendment('CPC Expiration Date') ? 'Edit Message' : 'Tag for Amendment' }}</button>
                        <span class="stat" [ngClass]="getStagedAmendment('CPC Expiration Date') ? 'stat-amend' : 'stat-review'" *ngIf="fleet.status === 'FOR_APPROVAL' || fleet.status === 'FOR_AMENDMENT'">{{ getStagedAmendment('CPC Expiration Date') ? 'For Amendment' : 'For Review' }}</span>
                      </div>
                      <p class="amend-note" *ngIf="getStagedAmendment('CPC Expiration Date') as note"><i class="fa fa-exclamation-circle"></i> {{ note.message }}</p>
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Valid LTFRB CPC Document</label>
                    <div class="col-sm-9">
                      <div class="detail-field">
                        <ng-container *ngIf="cpcDocument as doc; else noCpcDoc">
                          <div class="detail-doc">
                            <div class="docs-holder">
                              <img [src]="doc.documentUrl" alt="Valid LTFRB CPC Document" (error)="onDocumentImageError(doc)">
                            </div>
                            <a [href]="doc.documentUrl" target="_blank" rel="noopener">View Document</a>
                          </div>
                          <p class="amend-note" *ngIf="isDocumentLoadFailed(doc)"><i class="fa fa-exclamation-circle"></i> {{ documentLoadErrorMessage() }}</p>
                          <button type="button" class="detail-amend" *ngIf="canTagDocumentForAmendment(doc)" (click)="openReviewDocumentModal(reviewDocumentModal, doc, 'FOR_AMENDMENT')">Tag for Amendment</button>
                          <button type="button" class="detail-approve" *ngIf="canApproveDocument(doc)" (click)="openReviewDocumentModal(reviewDocumentModal, doc, 'APPROVED')">Approve</button>
                          <span class="stat" [ngClass]="getDocumentStatusClass(doc)">{{ getDocumentStatusLabel(doc) }}</span>
                        </ng-container>
                        <ng-template #noCpcDoc>
                          <span class="detail-value">No document attached.</span>
                        </ng-template>
                      </div>
                      <p class="amend-note" *ngIf="cpcDocument?.remarks as note"><i class="fa fa-exclamation-circle"></i> {{ note }}</p>
                      <ul class="doc-history" *ngIf="cpcDocument && documentHistory(cpcDocument).length">
                        <li *ngFor="let entry of documentHistory(cpcDocument)">
                          <strong>{{ historyActionLabel(entry.action) }}</strong>
                          <span *ngIf="entry.adminName"> · {{ entry.adminName }}</span>
                          <span *ngIf="entry.remarks"> — {{ entry.remarks }}</span>
                          <small>{{ entry.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A' }}</small>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Admin Account Details -->
            <div class="panel">
              <h3>Admin Account Details <small>Details of the Admin account owner of the Taxi Fleet operator</small></h3>
              <div class="panel-info" *ngIf="fleet.accountHolder as accountHolder; else noAccountHolder">
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Admin First Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="accountHolder.firstName || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Admin Last Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="accountHolder.lastName || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Email Address</label>
                    <div class="col-sm-9">
                      <div class="detail-field" *ngIf="accountHolder.isEmailVerified !== undefined && accountHolder.isEmailVerified !== null; else plainEmail">
                        <span class="detail-value">{{ accountHolder.email || '-' }}</span>
                        <a
                          *ngIf="!accountHolder.isEmailVerified"
                          href="javascript:void(0)"
                          class="detail-resend"
                          (click)="onResendEmailVerification()">
                          Resend Email Verification
                        </a>
                        <span class="stat" [ngClass]="accountHolder.isEmailVerified ? 'stat-active' : 'stat-inactive'">
                          {{ accountHolder.isEmailVerified ? 'Verified' : 'Not Verified' }}
                        </span>
                      </div>
                      <ng-template #plainEmail>
                        <div class="detail-field"><span class="detail-value">{{ accountHolder.email || '-' }}</span></div>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Mobile Number</label>
                    <div class="col-sm-9">
                      <div class="detail-field" *ngIf="accountHolder.isMobileVerified !== undefined && accountHolder.isMobileVerified !== null; else plainMobile">
                        <span class="detail-value">{{ accountHolder.mobile || '-' }}</span>
                        <a
                          *ngIf="!accountHolder.isMobileVerified"
                          href="javascript:void(0)"
                          class="detail-resend"
                          (click)="onResendMobileVerification()">
                          Resend Mobile Verification
                        </a>
                        <span class="stat" [ngClass]="accountHolder.isMobileVerified ? 'stat-active' : 'stat-inactive'">
                          {{ accountHolder.isMobileVerified ? 'Verified' : 'Not Verified' }}
                        </span>
                      </div>
                      <ng-template #plainMobile>
                        <div class="detail-field"><span class="detail-value">{{ accountHolder.mobile || '-' }}</span></div>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Role Type</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="accountHolder.role || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">User ID</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="accountHolder.fleetAccountId || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Created At</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="accountHolder.dateCreated ? (accountHolder.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A') : '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">Last Log in</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled [value]="accountHolder.lastLogin || '-'">
                    </div>
                  </div>
                </div>
                <div class="panel-grp">
                  <div class="mb-3 row">
                    <label class="col-sm-3 col-form-label">User Account Status</label>
                    <div class="col-sm-9">
                      <div class="detail-inline">
                        <span class="stat" [ngClass]="accountHolder.isActive ? 'stat-active' : 'stat-inactive'">
                          {{ accountHolder.isActive ? 'Active' : 'Inactive' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noAccountHolder>
                <div class="panel-info">
                  <div class="panel-grp">
                    <div class="mb-3 row">
                      <label class="col-sm-3 col-form-label">Admin Account</label>
                      <div class="col-sm-9">
                        <div class="detail-field"><span class="detail-value">-</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-container>

          <ng-container *ngIf="activeTab === 'registry'">
            <app-fleet-registry-batch [fleetId]="fleetId" (registryChanged)="fetchFleetRegistry()"></app-fleet-registry-batch>

            <div class="list-holder registry-list-holder">
              <div class="tools">
                <div class="list-title">
                  <h4>Fleet Registry</h4>
                </div>
              </div>
              <div class="list table-responsive">
                <div class="empty-state" *ngIf="isRegistryLoading">
                  <h4>Loading Fleet Registry...</h4>
                </div>

                <div class="empty-state" *ngIf="!isRegistryLoading && registryError">
                  <img src="../../../../assets/okito/images/empty.svg" alt="">
                  <h4>Unable to load Fleet Registry.</h4>
                  <small>{{ registryError }}</small>
                </div>

                <div class="empty-state" *ngIf="!isRegistryLoading && !registryError && registryItems.length === 0">
                  <img src="../../../../assets/okito/images/empty.svg" alt="">
                  <h4>No Fleet Vehicles yet.</h4>
                </div>

                <table *ngIf="!isRegistryLoading && !registryError && registryItems.length > 0">
                  <thead>
                    <tr>
                      <th>Plate Number</th>
                      <th>Conduction Sticker</th>
                      <th>Make/Model/Year</th>
                      <th>Assigned Driver</th>
                      <th>Registry Status</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of registryItems">
                      <td>{{ item.plateNumber || '—' }}</td>
                      <td>{{ item.conductionNumber || '—' }}</td>
                      <td>{{ getMakeModelYear(item) }}</td>
                      <td>{{ getAssignedDriver(item) }}</td>
                      <td>
                        <span class="stat" [ngClass]="getRegistryLifecycleClass(item)">
                          {{ getRegistryLifecycleLabel(item) }}
                        </span>
                      </td>
                      <td>
                        <span class="stat" [ngClass]="getRegistryStatusClass(item)">
                          {{ getRegistryStatusLabel(item) }}
                        </span>
                      </td>
                      <td>
                        <a href="#" (click)="$event.preventDefault(); onViewRegistryDetails(item, registryDetailsDrawer)">View Details</a>
                        <!-- Activate / Deactivate temporarily disabled
                        <ng-container *ngIf="canDeactivateRegistry(item)">
                          | <a href="#" (click)="$event.preventDefault(); openRegistryDeactivateModal(registryDeactivateModal, item)">Deactivate</a>
                        </ng-container>
                        <ng-container *ngIf="canActivateRegistry(item)">
                          | <a href="#" (click)="$event.preventDefault(); openRegistryActivateModal(registryActivateModal, item)">Activate</a>
                        </ng-container>
                        -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #updateStatusModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Update Fleet Status</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Status</label>
      <select
        class="form-select"
        [(ngModel)]="selectedStatus"
        name="selectedStatus"
        [disabled]="isUpdatingStatus"
        (ngModelChange)="onStatusChange()">
        <option *ngFor="let option of statusOptions" [ngValue]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>

    <div class="form-item" *ngIf="isDeclineSelected">
      <label class="form-label">Decline Remarks</label>
      <textarea
        class="form-control"
        rows="3"
        name="declineRemarks"
        placeholder="Enter reason for declining"
        [(ngModel)]="declineRemarks"
        [disabled]="isUpdatingStatus">
      </textarea>
    </div>

    <div class="form-level-error" *ngIf="statusFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ statusFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="confirmUpdateStatus(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Updating...' : 'Update Status' }}
    </button>
  </div>
</ng-template>

<ng-template #declineEnrollmentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Decline Fleet Operator</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-item">
      <label class="form-label">Message</label>
      <p class="form-help">Add a reason for the declined enrollment. The Fleet Operator Admin will be notified.</p>
      <textarea
        class="form-control"
        rows="3"
        maxlength="200"
        name="enrollmentDeclineRemarks"
        placeholder="Enter the reason for declining"
        [(ngModel)]="declineRemarks"
        [disabled]="isUpdatingStatus">
      </textarea>
      <p class="char-count">{{ declineRemarks.length }}/200</p>
      <span class="error-required" *ngIf="statusFormError">{{ statusFormError }}</span>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="confirmDeclineEnrollment(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Submitting...' : 'Submit' }}
    </button>
  </div>
</ng-template>

<ng-template #tagForAmendmentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">For Amendment</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-item">
      <label class="form-label">Field tagged</label>
      <input type="text" class="form-control" disabled [value]="pendingFieldName">
    </div>
    <div class="form-item">
      <label class="form-label">Message</label>
      <textarea
        class="form-control"
        rows="4"
        maxlength="500"
        name="pendingMessage"
        placeholder="Tell the Fleet Operator what needs to be corrected"
        [(ngModel)]="pendingMessage">
      </textarea>
      <p class="char-count">{{ pendingMessage.length }}/500</p>
      <span class="error-required" *ngIf="statusFormError">{{ statusFormError }}</span>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-default" (click)="confirmFieldAmendment(modal)">Tag for Amendment</button>
  </div>
</ng-template>

<ng-template #reviewDocumentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ pendingReviewStatus === 'APPROVED' ? 'Approve Document' : 'Tag Document for Amendment' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isReviewingDocument" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-item">
      <label class="form-label">Document</label>
      <input type="text" class="form-control" disabled [value]="pendingReviewDoc ? getDocumentLabelForReview(pendingReviewDoc) : ''">
    </div>
    <div class="form-item" *ngIf="pendingReviewStatus === 'FOR_AMENDMENT'">
      <label class="form-label">Message</label>
      <textarea
        class="form-control"
        rows="4"
        maxlength="500"
        name="documentReviewRemarks"
        placeholder="Tell the Fleet Operator what needs to be corrected"
        [(ngModel)]="documentReviewRemarks"
        [disabled]="isReviewingDocument">
      </textarea>
      <p class="char-count">{{ documentReviewRemarks.length }}/500</p>
    </div>
    <p *ngIf="pendingReviewStatus === 'APPROVED'">Approve this document? You can also approve the entire enrollment later — any documents still awaiting review will be approved automatically with the enrollment.</p>
    <span class="error-required" *ngIf="statusFormError">{{ statusFormError }}</span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isReviewingDocument" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-default" [disabled]="isReviewingDocument" (click)="confirmReviewDocument(modal)">
      <i *ngIf="isReviewingDocument" class="fa fa-spinner fa-spin"></i>
      {{ isReviewingDocument ? 'Submitting...' : (pendingReviewStatus === 'APPROVED' ? 'Approve Document' : 'Tag for Amendment') }}
    </button>
  </div>
</ng-template>

<ng-template #approveModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Approve Fleet Operator</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Approve this Fleet Operator? Any documents still awaiting review will be approved with the enrollment. An activation email will be sent and the business status will be tagged as Active.</p>
    <p class="form-help" *ngIf="hasDocumentsForAmendment">Some documents are tagged for amendment. Wait for the Fleet Operator to resubmit them before approving.</p>
    <div class="form-level-error" *ngIf="statusFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ statusFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">No, thanks</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="onApproveEnrollment(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Submitting...' : "Yes, I'm sure" }}
    </button>
  </div>
</ng-template>

<ng-template #amendmentSummaryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Send for Amendment</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Submit field amendments for CPC details? The Fleet Operator will receive one email containing your message for each field below. Document amendments are submitted separately per document.</p>
    <ul class="amend-summary">
      <li *ngFor="let item of stagedAmendments">
        <span class="amend-summary-field">{{ item.fieldName }}</span>
        <span class="amend-summary-msg">{{ item.message }}</span>
      </li>
    </ul>
    <div class="form-level-error" *ngIf="statusFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ statusFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">No, thanks</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="confirmSendForAmendment(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Submitting...' : "Yes, I'm sure" }}
    </button>
  </div>
</ng-template>

<!-- Activate / Deactivate temporarily disabled
<ng-template #registryDeactivateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Deactivate Vehicle</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingRegistryStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to deactivate this vehicle?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingRegistryStatus" (click)="modal.dismiss()">No, thanks</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingRegistryStatus" (click)="confirmRegistryDeactivate(modal)">
      <i *ngIf="isUpdatingRegistryStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingRegistryStatus ? 'Updating...' : "Yes, I'm sure" }}
    </button>
  </div>
</ng-template>

<ng-template #registryActivateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Activate Vehicle</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingRegistryStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to activate this vehicle?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingRegistryStatus" (click)="modal.dismiss()">No, thanks</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingRegistryStatus" (click)="confirmRegistryActivate(modal)">
      <i *ngIf="isUpdatingRegistryStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingRegistryStatus ? 'Updating...' : "Yes, I'm sure" }}
    </button>
  </div>
</ng-template>
-->


<ng-template #activateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Activate Fleet Operator</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to activate this Fleet Operator?</p>
    <div class="form-level-error" *ngIf="statusFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ statusFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">No, thanks</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="confirmActivate(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Updating...' : "Yes, I'm sure" }}
    </button>
  </div>
</ng-template>

<ng-template #deactivateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Deactivate Fleet Operator</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isUpdatingStatus" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to deactivate this Fleet Operator?</p>
    <div class="form-item" style="margin-top: 16px;">
      <label class="form-label">Notes</label>
      <textarea
        class="form-control"
        rows="3"
        name="deactivateNotes"
        placeholder="Enter notes for deactivation"
        [(ngModel)]="declineRemarks"
        [disabled]="isUpdatingStatus">
      </textarea>
    </div>
    <div class="form-level-error" *ngIf="statusFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ statusFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isUpdatingStatus" (click)="modal.dismiss()">No, thanks</button>
    <button type="button" class="btn btn-default" [disabled]="isUpdatingStatus" (click)="confirmDeactivate(modal)">
      <i *ngIf="isUpdatingStatus" class="fa fa-spinner fa-spin"></i>
      {{ isUpdatingStatus ? 'Updating...' : "Yes, I'm sure" }}
    </button>
  </div>
</ng-template>


<ng-template #editFleetModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Edit Fleet Operator</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isSavingEdit" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Taxi Fleet Operator Name</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.operatorName" name="editOperatorName" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('operatorName')">{{ editFieldErrors.operatorName }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Registered Business Name</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.registeredBusinessName" name="editRegisteredBusinessName" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('registeredBusinessName')">{{ editFieldErrors.registeredBusinessName }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Fleet Type</label>
      <select class="form-select" [(ngModel)]="editForm.fleetType" name="editFleetType" [disabled]="isSavingEdit" (ngModelChange)="onEditFleetTypeChange()">
        <option *ngFor="let option of fleetTypeOptions" [ngValue]="option.value">{{ option.label }}</option>
      </select>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Number of Allowed Active Vehicles</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.allowedActiveVehicles" name="editAllowedActiveVehicles" [disabled]="isSavingEdit" (input)="onAllowedActiveVehiclesInput($event)">
      <span class="error-required" *ngIf="hasEditFieldError('allowedActiveVehicles')">{{ editFieldErrors.allowedActiveVehicles }}</span>
    </div>
    <hr>
    <h6>Operator Representative</h6>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">First Name</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.representativeFirstName" name="editRepFirstName" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('representativeFirstName')">{{ editFieldErrors.representativeFirstName }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Last Name</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.representativeLastName" name="editRepLastName" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('representativeLastName')">{{ editFieldErrors.representativeLastName }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Mobile Number</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.representativeMobile" name="editRepMobile" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('representativeMobile')">{{ editFieldErrors.representativeMobile }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Representative Email</label>
      <input type="email" class="form-control" [(ngModel)]="editForm.representativeEmail" name="editRepEmail" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('representativeEmail')">{{ editFieldErrors.representativeEmail }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;" *ngIf="!isEditCpcDisabled">
      <label class="form-label">Valid LTFRB CPC Number</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.ltfrbCpcNumber" name="editLtfrbCpcNumber" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('ltfrbCpcNumber')">{{ editFieldErrors.ltfrbCpcNumber }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;" *ngIf="!isEditCpcDisabled">
      <label class="form-label">CPC Expiration Date</label>
      <input type="date" class="form-control" [(ngModel)]="editForm.cpcExpirationDate" name="editCpcExpirationDate" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('cpcExpirationDate')">{{ editFieldErrors.cpcExpirationDate }}</span>
    </div>
    <hr>
    <h6>Admin Account</h6>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Admin First Name</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.adminFirstName" name="editAdminFirstName" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('adminFirstName')">{{ editFieldErrors.adminFirstName }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Admin Last Name</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.adminLastName" name="editAdminLastName" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('adminLastName')">{{ editFieldErrors.adminLastName }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Email Address</label>
      <input type="email" class="form-control" [(ngModel)]="editForm.adminEmail" name="editAdminEmail" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('adminEmail')">{{ editFieldErrors.adminEmail }}</span>
    </div>
    <div class="form-item" style="margin-bottom: 16px;">
      <label class="form-label">Mobile Number</label>
      <input type="text" class="form-control" [(ngModel)]="editForm.adminMobile" name="editAdminMobile" [disabled]="isSavingEdit">
      <span class="error-required" *ngIf="hasEditFieldError('adminMobile')">{{ editFieldErrors.adminMobile }}</span>
    </div>
    <div class="form-level-error" *ngIf="editFormError" style="margin-top: 16px;">
      <i class="fa fa-exclamation-circle"></i> {{ editFormError }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isSavingEdit" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-default" [disabled]="isSavingEdit" (click)="confirmEditFleet(modal)">
      <i *ngIf="isSavingEdit" class="fa fa-spinner fa-spin"></i>
      {{ isSavingEdit ? 'Saving...' : 'Save Changes' }}
    </button>
  </div>
</ng-template>

<ng-template #resendCredentialsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Resend Log-in Credentials</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isResendingCredentials" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Resend temporary login credentials to the Fleet Operator admin for <strong>{{ fleet?.operatorName }}</strong>?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" [disabled]="isResendingCredentials" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-default" [disabled]="isResendingCredentials" (click)="confirmResendCredentials(modal)">
      <i *ngIf="isResendingCredentials" class="fa fa-spinner fa-spin"></i>
      {{ isResendingCredentials ? 'Sending...' : 'Resend Credentials' }}
    </button>
  </div>
</ng-template>

<ng-template #registryDetailsDrawer let-offcanvas>
  <div class="offcanvas-header" *ngIf="selectedRegistry as registry">
    <h5 id="offcanvasRightLabel">
      Vehicle Registry Details
      <small>{{ getPlateOrConduction(registry) }}</small>
    </h5>
    <button type="button" class="btn-close text-reset" (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body" *ngIf="selectedRegistry as registry">
    <div class="booking-holder">
      <h5>Registry Summary</h5>
      <div class="info-grid">
        <div class="info-cell">
          <label>Registry ID</label>
          <div class="detail-field"><span class="detail-value">{{ registry.fleetVehicleRegistryId || '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Plate Number</label>
          <div class="detail-field"><span class="detail-value">{{ registry.plateNumber || '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Conduction Number</label>
          <div class="detail-field"><span class="detail-value">{{ registry.conductionNumber || '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Vehicle Maker</label>
          <div class="detail-field"><span class="detail-value">{{ registry.vehicleMaker || '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Vehicle Model</label>
          <div class="detail-field"><span class="detail-value">{{ registry.vehicleModel || '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Year Model</label>
          <div class="detail-field"><span class="detail-value">{{ registry.yearModel != null ? registry.yearModel : '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Vehicle Type</label>
          <div class="detail-field"><span class="detail-value">{{ registry.vehicleType || '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Vehicle ID</label>
          <div class="detail-field"><span class="detail-value">{{ registry.vehicleId || '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Status</label>
          <div class="detail-inline">
            <span class="stat" [ngClass]="getRegistryStatusClass(registry)">
              {{ getRegistryStatusLabel(registry) }}
            </span>
          </div>
        </div>
        <div class="info-cell">
          <label>Assigned Driver</label>
          <div class="detail-field"><span class="detail-value">{{ getAssignedDriver(registry) }}</span></div>
        </div>
        <div class="info-cell" *ngIf="registry.associatedPartner as partner">
          <label>Driver Mobile</label>
          <div class="detail-field"><span class="detail-value">{{ partner.mobile || '—' }}</span></div>
        </div>
        <div class="info-cell" *ngIf="registry.associatedPartner as partner">
          <label>Driver Membership ID</label>
          <div class="detail-field"><span class="detail-value">{{ partner.membershipId || '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Created At</label>
          <div class="detail-field"><span class="detail-value">{{ registry.dateCreated ? (registry.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A') : '—' }}</span></div>
        </div>
        <div class="info-cell">
          <label>Updated At</label>
          <div class="detail-field"><span class="detail-value">{{ registry.dateUpdated ? (registry.dateUpdated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A') : '—' }}</span></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
